import React from 'react';
import ContentHeightSubject from './ContentHeightSubject';
import {useForestCompositionState} from './ForestCompositionContext';
const percent = f => (f*100).toFixed(0) + '%';

const Matrix = ({refData}) => {
	React.useEffect(() => {
      ContentHeightSubject.contentHeightDidChange();
	});
	let {forest} = useForestCompositionState();
	forest = forest || {trees:[],pests:[]};
	const {trees,pests} = forest;
	return trees.length === 0
		?
			<table className="table table-bordered">
				<tbody>
					<tr>
						<td className="text-center">
							Compose your forest above, then review its vulnerabilities here.
							{/*
								{' '}<span role="img" aria-label="insect">🐞</span>
								{' '}<span role="img" aria-label="disease">🦠</span>
								{' '}<span role="img" aria-label="insect">🐞</span>
								{' '}<span role="img" aria-label="disease">🦠</span>
								{' '}<span role="img" aria-label="insect">🦗</span>
								{' '}<span role="img" aria-label="insect">🐜</span>
								{' '}<span role="img" aria-label="insect">🐛</span>
								{' '}<span role="img" aria-label="eyes">👀</span>
							*/}
						</td>
					</tr>
				</tbody>
			</table>
		:
			<table className="table table-bordered table-sm">
				<thead>
					<tr>
						{trees.map(t => (
							<th className="vertical-th" key={t.id}>
								<div>
									<div>
										{t.name}
									</div>
								</div>
							</th>
						))}
						<th className="vertical-th">
							<div>
								<div style={{ fontWeight: 'normal' }}>
										Tree species affected
								</div>
							</div>
						</th>
						<th className="vertical-th">
							<div>
								<div style={{ fontWeight: 'normal' }}>
									Tree population affected
								</div>
							</div>
						</th>
						<th>&nbsp;</th>
					</tr>

					<tr>
						{trees.map((t, i) => (
							<td key={t.id} className="text-center">
								{t.proportion}%
							</td>
						))}
						<td colSpan="3">&nbsp;</td>
					</tr>
				</thead>
				<tbody>
					{pests.map((p, pi) => (
						<tr key={pi}>
							{p.severityByTree.map((v, ti) => (
								<td key={ti} className={"severity severity-" + v} title={"Severity: " + refData.severityLabelByValue[v]}>
									{/*
									{refData.severityLabelByValue[v]}
									*/}
									{(() => {
										switch(v){
											case 1: return <span role="img" aria-label="!">!</span>;
											case 2: return <span role="img" aria-label="!">!!</span>;
											case 3: return <span role="img" aria-label="!">!!!</span>;
											default: return <></>;
										}
									})()}
								</td>
							))}
							<td>
								{percent(p.percentageOfSpeciesAffected)}
							</td>
							<td>
								{percent(p.percentageOfPopulationAffected)}
							</td>
							<td>
								<div className="single-line">
									{p.types.map((t, ti) => (
										<span
											key={ti}
											className="mr-1 badge badge-secondary"
											title={refData.pestTypeLabelByCode[t]}>{t}</span>
									))}
									{p.name}
								</div>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		;
}

export default Matrix;